import req from 'utils/req';

export function fetchForSearch({ shortIds, language, maxCommentLength }) {
  return req(
    `${URL_API_HOST}/api/v1/review/by-experience-short-ids?ids=${shortIds.join(
      ',',
    )}&lang=${language}&max_comment_length=${maxCommentLength}`,
  ).get();
}

export function fetchReview(reviewId) {
  return req(`${URL_API_HOST}/api/v1/review/${reviewId}`).get();
}

export interface PublicReviewReturnType {
  host?: {
    firstName: string;
    photo: string;
  };
  reviewer?: {
    firstName: string;
  };
  city?: string;
  tripCanBeReviewed: boolean;
  accountCanReviewTrip: boolean;
  tripAlreadyReviewed: boolean;
  experienceId?: string;
}

export function fetchPublicReviewDetails({
  tripId,
  accountId,
}: {
  tripId: string;
  accountId: string;
}): Promise<PublicReviewReturnType> {
  return req(
    `${URL_API_HOST}/api/v2/review/details/${tripId}/${accountId}/public`,
  ).get();
}

export interface PostReviewInterface {
  rating: number | string;
  price_value_rating: number | string;
  title: string;
  comment: string;
  trip_id: string;
}

export function postReview({
  rating,
  price_value_rating,
  title,
  comment,
  trip_id,
}: PostReviewInterface) {
  return req(`${URL_API_HOST}/api/v2/review`).post({
    title,
    comment,
    trip_id,
    rating: Number(rating),
    price_value_rating: Number(price_value_rating),
  });
}

export interface PostPublicReviewInterface {
  accountId: string;
  tripId: string;
  rating: number | string;
  priceValueRating: number | string;
  comment?: string;
  title?: string;
}

export function postPublicReview({
  accountId,
  tripId,
  rating,
  priceValueRating,
  comment,
  title,
}: PostPublicReviewInterface) {
  return req(`${URL_API_HOST}/api/v2/review/public`).post({
    accountId,
    tripId,
    rating,
    priceValueRating,
    scale: 10,
    comment,
    title,
  });
}

interface PostExtendedReviewInterface {
  nps: string | number;
  possible_improvements: string;
}

export function postExtendedReview(
  reviewId: string,
  body: PostExtendedReviewInterface,
) {
  return req(`${URL_API_HOST}/api/v2/review/${reviewId}/extended`).post(body);
}

export function postExtendedPublicReview(
  reviewId: string,
  body: PostExtendedReviewInterface,
  accountId: string,
) {
  return req(
    `${URL_API_HOST}/api/v2/review/${reviewId}/${accountId}/extended/public`,
  ).post(body);
}

export function addUpvoteToReview(reviewId: string) {
  return req(`${URL_API_HOST}/api/v1/review/vote/up/${reviewId}`).post();
}

export function removeUpvoteFromReview(reviewId: string) {
  return req(`${URL_API_HOST}/api/v1/review/vote/up/${reviewId}`).delete();
}
